import reducer from './reducers'

import * as workerCallsOperations from './operations'
import * as workerCallsEndpoints from './paths'

export { workerCallsOperations, workerCallsEndpoints }

export default reducer
